'use client'

import React from 'react'

type Props = {
    airDensity: number
    sweptArea: number
    windSpeed: number
}

const WIDTH = 340
const HEIGHT = 200
const PAD_LEFT = 44
const PAD_RIGHT = 12
const PAD_TOP = 14
const PAD_BOTTOM = 28
const PLOT_W = WIDTH - PAD_LEFT - PAD_RIGHT
const PLOT_H = HEIGHT - PAD_TOP - PAD_BOTTOM

export default function WindPowerChart({ airDensity, sweptArea, windSpeed }: Props) {
    const vMax = Math.max(windSpeed * 1.4, 0.1)
    const powerAt = (v: number) => 0.5 * airDensity * sweptArea * v * v * v
    const pMax = Math.max(powerAt(vMax), 0.0001)

    const xToSvg = (v: number) => PAD_LEFT + (v / vMax) * PLOT_W
    const yToSvg = (p: number) => PAD_TOP + PLOT_H - (p / pMax) * PLOT_H

    const steps = 40
    const points: string[] = []
    for (let i = 0; i <= steps; i++) {
        const v = (vMax * i) / steps
        points.push(`${xToSvg(v).toFixed(1)},${yToSvg(powerAt(v)).toFixed(1)}`)
    }

    const markerX = xToSvg(windSpeed)
    const markerY = yToSvg(powerAt(windSpeed))

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <line x1={PAD_LEFT} y1={PAD_TOP} x2={PAD_LEFT} y2={HEIGHT - PAD_BOTTOM} stroke="#9ca3af" strokeWidth={1} />
            <line x1={PAD_LEFT} y1={HEIGHT - PAD_BOTTOM} x2={WIDTH - PAD_RIGHT} y2={HEIGHT - PAD_BOTTOM} stroke="#9ca3af" strokeWidth={1} />
            <text x={PAD_LEFT} y={HEIGHT - 8} fontSize={10} fill="#6b7280">Wind Speed (m/s)</text>
            <text x={4} y={PAD_TOP + 6} fontSize={10} fill="#6b7280">Power (W)</text>
            <polyline points={points.join(' ')} fill="none" stroke="#2563eb" strokeWidth={2} />
            <line x1={markerX} y1={markerY} x2={markerX} y2={HEIGHT - PAD_BOTTOM} stroke="#dc2626" strokeWidth={1} strokeDasharray="3,3" opacity={0.6} />
            <circle cx={markerX} cy={markerY} r={4.5} fill="#dc2626" stroke="#fff" strokeWidth={1.5} />
        </svg>
    )
}
